import React from "react";

interface IIconBarCode {
  width?: number;
  height?: string;
  className?: string;
}

export default function IconBarCode({ width = 20, height = "auto", className}:IIconBarCode) {
  return (
    <div className={className}>
      <svg width={width} height={height}  viewBox="0 0 28 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M1 10V18.4805H2.47266H3.94531V10V1.51953H2.47266H1V10ZM5.72266 10V18.4805H6.48438H7.24609V10V1.51953H6.48438H5.72266V10ZM9.125 10V18.4805H11.334H13.543V10V1.51953H11.334H9.125V10ZM14.8633 10V18.4805H15.625H16.3867V10V1.51953H15.625H14.8633V10ZM17.4531 10V18.4805H18.2148H18.9766V10V1.51953H18.2148H17.4531V10ZM20.0938 10V18.4805H21.5918H23.0898V10V1.51953H21.5918H20.0938V10ZM23.6992 10V18.4805H24.4355H25.1719V10V1.51953H24.4355H23.6992V10ZM26.2383 10V18.4805H26.6191H27V10V1.51953H26.6191H26.2383V10Z"/>
      </svg>
    </div>
  );
}